import currentReleaseInfo from "@/../release-info.json"

type CachedEntry<T> = {
  data: T
  versionSourceCommit: string
  timestamp: number
}

const invokeDefaultFn = async <T>(fn: () => Promise<T>, key: string) => {
  const data = await fn()

  const newEntry: CachedEntry<T> = {
    data,
    versionSourceCommit: currentReleaseInfo.sourceCommit,
    timestamp: Date.now(),
  }

  localStorage.setItem(key, JSON.stringify(newEntry))
  return newEntry.data
}

export const cacheOrDefault = async <T>(key: string, fn: () => Promise<T>) => {
  // Outside a pipeline build release-info.json is the committed sample, so its commit never changes.
  if (import.meta.env.MODE !== "production") {
    return await fn()
  }

  const parsed: CachedEntry<T> | null = JSON.parse(localStorage.getItem(key)!)
  if (parsed && parsed.versionSourceCommit === currentReleaseInfo.sourceCommit) {
    return parsed.data
  }

  return await invokeDefaultFn<T>(fn, key)
}

export const cacheOrDefaultWithLifetime = async <T>(key: string, lifetime: number, fn: () => Promise<T>) => {
  const parsed: CachedEntry<T> | null = JSON.parse(localStorage.getItem(key)!)
  if (parsed && Date.now() - parsed.timestamp < lifetime) {
    return parsed.data
  }

  return await invokeDefaultFn<T>(fn, key)
}
